module.exports = __webpack_public_path__ + "static/media/focus-main-1.45b73ef7.jpg";